module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.8cac70eb.woff";